module.exports = __webpack_public_path__ + "img/OFICINA TECNICA.c708a1fd.png";